import React from 'react';

// See more loading icons here:
// https://fontawesome.com/how-to-use/on-the-web/styling/animating-icons
const Loader = ({ className }) => (
    <em className={`fas fa-circle-notch fa-spin fa-2x ${className}`}></em>
)

export default Loader;
